import { render } from "./bestCombination.vue?vue&type=template&id=406da780&ts=true"
import script from "./bestCombination.vue?vue&type=script&lang=ts"
export * from "./bestCombination.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__